import type { IStrapiImage } from './strapiImage';

export enum SettingsId {
  Dashboard = 'dashboard',
  Profile = 'profile',
  Security = 'security',
  Verification = 'verification',
  History = 'history',
}

export enum eHistoryTab {
  Transactions = 'transactionHistory',
  Bonuses = 'bonusHistory',
  Bets = 'betsHistory',
}

export type tPersonalInfo = {
  title: string;
  completedProfileText: string;
  btnToProfileInfo: string;
  btnCompleteProfile: string;
};
export type tSecurityTab = {
  title: string;
  emailConfirmTitle: string;
  phoneNumberTitle: string;
  twoFactorTitle: string;
  btnComplete: string;
  btnSettings: string;
  statusStrong: string;
  statusMedium: string;
  statusWeak: string;
  statusWarning: string;
  warningText: string;
  strongText: string;
};
export type tPromoSettings = {
  title: string;
  subtitleText: string;
  emailPromoText: string;
  pushPromoText: string;
  smsText: string;
  couponError: string;
  couponToastTitle: string;
  couponToastText: string;
};
export type tEmailVerification = {
  title: string;
  emailSentText: string;
  btnResendEmail: string;
  btnSendEmail: string;
};
export type tChangePassword = {
  title: string;
  subtitleText: string;
  currentPasswordText: string;
};
export type tTwoFactorAuth = {
  title: string;
  successText: string;
  subtitleText: string;
  firstStepText: string;
  secondStepText: string;
  thirdStepText: string;
  twoFactorDisableText: string;
  enterCodeText: string;
  securityCodeText: string;
};
export type tSessionHistory = {
  title: string;
  deviceTitle: string;
  locationTitle: string;
  ipTitle: string;
  lastUsedTitle: string;
  actionTitle: string;
  currentText: string;
  btnTerminate: string;
  closedText: string;
};
export type tDocumentsBlock = {
  identityTitle: string;
  fronSideText: string;
  backSideText: string;
  uploadDocumentText: string;
  btnUpload: string;
  passportTitle: string;
  otherDocTitle: string;
  driverLicenseTitle: string;
  uploadedDocsTitle: string;
  dropFilesText: string;
  btnBrowse: string;
  formatSizeRestrictionsText: string;
  errorWrongFormat: string;
  errorTooLargeFile: string;
  addressTitle: string;
  addressSubtitle: string;
  paymentTitle: string;
  paymentSubtitle: string;
  otherTitle: string;
  otherSubtitle: string;
  chooseDocumentText: string;
  docStatusSeen: string;
  docStatusNotApproved: string;
  docStatusPending: string;
  docStatusSuccess: string;
};
export type tGuideModal = {
  title: string;
  subTitle: string;
  goodBadTextList: { title: string; type: 'good' | 'bad' }[];
  goodBadImageList: {
    title: string;
    imageGood?: IStrapiImage;
    imageBad?: IStrapiImage;
    afterImagesText?: string;
  }[];
};
export type tPagesTitles = {
  dashboardPageTitle: string;
  profilePageTitle: string;
  securityPageTitle: string;
  verificationPageTitle: string;
  gamblingLimitsTitle: string;
  selfExclusionTitle: string;
};
export type tPagesTitlesResp = {
  gamblingLimitsTitle: string;
  selfExclusionTitle: string;
};
export type tPeriodOptions = {
  day: string;
  day_3: string;
  week: string;
  month: string;
  month_3: string;
  month_6: string;
};
export type tExclusionModal = {
  title: string;
  afterSelectText: string;
  beforeConfirmTextBlock: string;
  editTitle?: string;
};
export type tCoolingOff = {
  title: string;
  bottomText: string;
  modalContent: tExclusionModal;
};
export type tLimitsGeneralData = {
  periodDaily: string;
  periodWeekly: string;
  periodMonthly: string;
  titleCurrency: string;
  titleAmount: string;
  titleProgress: string;
  titlePeriod: string;
  noLimitText: string;
  maximumProgress: string;
  alreadyUsedText: string;
  newLimitBiggerText: string;
  btnAddLimit: string;
  btnEdit: string;
  textModalBottom: string;
  btnAddNew: string;
  noAvailableCurrencyDeposit: string;
  untilResetText: string;
};
export type tLimitBlock = {
  title: string;
  subtitle: string;
  modalTitleSet: string;
  modalTitleChange: string;
};
export type tSessionLimit = {
  title: string;
  bottomText: string;
  minutesPlaceholder: string;
  editSessionLimitTitle: string;
  setInMinutesText: string;
};
